<template>
	<div class="container-wrap">
		<div class="container">
			<div class="aside">
				<asideVideo :current="curNameId" :isAll="isAll" :isShowAll="true" @toList="toList" :menuList="menuList"/>
			</div>
			<div class="content">
				<ul class="list">
					<li v-for="item in dataList" @click="toDetail(item.id)">
						<div class="list-item">
							<div class="list-img">
								<img :src="item.picUrl" />
							</div>
							<div class="list-title">
								<h3>{{item.title}}</h3>
							</div>
							<div class="list-txt">
								{{item.introduction}}
							</div>
						</div>
					</li>
				</ul>
				<div class="pagination-wrap">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :page-size= this.pageSize
					  :total=this.total
					  @current-change="handleCurrentChange"
					  hide-on-single-page
					  >
					</el-pagination>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	import asideVideo from '@/components/product/asideVideo'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Home',
		components: {
			asideVideo
		},
		data() {
			return {
				currentMenu: 0,
				menuList: [],
				id: '',
				categoryIdOne: '',
				categoryIdTwo: '',
				dataList: [],
				pageNum: 1,
				pageSize: 6,
				total: 0,
				curNameId: 0,
				isAll: true
			}
		},
		created(){
			let id = this.$route.params.id
			this.id = id
			this.getCateList()
		},
		watch: {
			$route(to,from) {
				let id = this.$route.params.id
				this.id = id
				this.categoryIdOne = ''
				this.categoryIdTwo = ''
				this.curNameId = 0
				this.pageNum = 1
				this.total = 0
				this.isAll = true
				this.getCateList()
			}
		},
		methods: {
			//获取新闻类型
			async getCateList(){
				let param = {
					id: this.id,
					typeCode: 'video'
				}
				ajaxParam(param)
				const res = await post('v1/category/tree', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					for(var i=0; i<list.length; i++){
						list[i].isShowChild = true
					}
					this.menuList = list
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取当前列表数据
			async getDataList(){
				let param = {
					categoryIdOne: this.categoryIdOne,
					categoryIdTwo: this.categoryIdTwo,
					columnId: this.id,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/video/list', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
			toList(e){
				this.curNameId = e.id
				if(e.parentId) {
					this.categoryIdOne = e.parentId
					this.categoryIdTwo = e.id
				} else{
					this.categoryIdOne = e.id
					this.categoryIdTwo = ''
				}
				if(e.isAll) {
					this.categoryIdOne = ''
					this.categoryIdTwo = ''
				}
				this.isAll = e.isAll
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toDetail(id){
				this.$router.push({
					path: '/videoDetail/'+this.id+'/'+id
				})
			}
		}
	}
</script>
<style scoped lang="less">
	.container{
		padding: 26px 0 10px;
		.aside{
			float: left;
			width: 280px;
			height: 400px;
			background: #fff;
		}
		.content{
			float: right;
			width: 880px;
			padding-top: 0;
			.list{
				display: flex;
				flex-wrap: wrap;
				padding: 0 24px;
				li{
					display: flex;
					flex-direction: column;
					width: 33.3333%;
					padding-left: 8px;
					padding-right: 8px;
					margin-bottom: 16px;
					box-sizing: border-box;
					cursor: pointer;
					.list-item{
						background:#fff;
						border-radius: 4px;
						overflow: hidden;
					}
					.list-img{
						img{
							width: 100%;
							height: 160px;
							max-width: 380px;
							max-height: 214px;
						}
					}
					.list-title{
						margin-top: 12px;
						margin-bottom: 4px;
						padding: 0  17px;
						font-weight: 500;
						line-height: 20px;
						font-size: 14px;
						color: #423f3f;
						letter-spacing: .86px;
						-webkit-line-clamp: 2;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}
					.list-txt{
						margin-bottom: 10px;
						padding: 0 17px;
						font-size: 12px;
						color: #423f3f;
						letter-spacing: .86px;
						-webkit-line-clamp: 1;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}
				}
				.list-item:hover{
					position: relative;
					box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
					border-radius: 6px;
					z-index: 1
				}
			}
		}
	}
</style>
